import { functions } from './initialise'
import { httpsCallable } from "firebase/functions";

export const getAccount = () => {
    const onboard = httpsCallable(functions, 'onboard');
    return onboard()
}